var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.0-parallel-run-(Sprint28-8.1)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m.sp4e",
    transform: "translate(-17.000000, -775.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(17.000000, 775.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(3.500000, 3.500000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#333333",
    strokeWidth: 1.5,
    x: 0,
    y: 0,
    width: 12.037037,
    height: 9,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#333333",
    x: 0.462962963,
    y: 0,
    width: 12.037037,
    height: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    fill: "#333333"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "15.5 0 19.5 0 19.5 4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy",
    transform: "translate(2.000000, 2.000000) scale(-1, 1) translate(-2.000000, -2.000000) ",
    points: "0 0 4 0 4 4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(9.601852, 13.500000) scale(1, -1) translate(-9.601852, -13.500000) translate(0.000000, 11.500000)",
    fill: "#333333"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-2",
    points: "15.5 0 19.2037037 0 19.2037037 4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-5",
    transform: "translate(1.851852, 2.000000) scale(-1, 1) translate(-1.851852, -2.000000) ",
    points: "0 0 3.7037037 0 3.7037037 4"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToDesktop);
export default __webpack_public_path__ + "static/media/toDesktop.b53adc9158bf33711ed1175137ae1cd4.svg";
export { ForwardRef as ReactComponent };